import { useEffect, useState } from "react";
import PageContent from "../components/PageContent";
import LoyaltyTrackerRow from "../components/LoyaltyTrackerRow";
import domain from "../domain";
import classes from "./LoyaltyTrackerPage.module.css";
import { getRestaurantId, getHqRid } from "../util/getIds";
// The questions object is populated by the existing /api/questions request.
// Optional chaining handles a missing localStorage entry without crashing.

async function fetchLoyaltyData(restaurantId,type) {
  // restaurantId goes in the query string since GET has no body.
  // Auth is handled via cookies: credentials "include" makes the browser
  // attach them even though the backend runs on a different origin.
  const res = await fetch(
    `${domain}/api/loyaltytracker?restaurantId=${encodeURIComponent(restaurantId)}&type=${type}`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!res.ok) {
    throw new Error(`Request failed with status ${res.status}`);
  }
  return res.json();
}

async function acceptLoyaltyEntry(restaurantId, phone,name) {
//   console.log("acceptLoyaltyEntry", restaurantId, phone, name);
  const res = await fetch(
    `${domain}/api/loyaltytracker/accept`,
    {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ restaurantId: restaurantId, phone: phone, name: name }),
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  let result = await res.json();
  console.log("XXXresult", result );
  if (!res.ok) {
    throw new Error(`Request failed with status ${res.status}`);
  }
  return result;
}

export default function LoyaltyTrackerPage() {
  const role = localStorage.getItem("role");
  const isHq = role === "hq";
  const [data, setData] = useState(null);
  const [newData, setNewData] = useState(null);
  const [status, setStatus] = useState("loading"); // "loading" | "ready" | "error"
  const [errorMsg, setErrorMsg] = useState("");
  // Incrementing this state re-runs the effect, refetching the data.
  // Keeping the fetch inside the effect gives the initial load and the
  // refresh button one shared code path with proper cleanup.
  const [refreshCount, setRefreshCount] = useState(0);
  // null until Refresh is clicked. "fetching" hides the success line immediately;
  // "success" is set only after the type=new response arrives.
  const [refreshStatus, setRefreshStatus] = useState(null);
  const [actionError, setActionError] = useState("");
  const [offerData, setOfferData] = useState(null);

  useEffect(() => {
    if (isHq) return;
    // console.log("useEffect", refreshCount);
    let ignore = false; // guards against setState after unmount / double-invoke in StrictMode

    async function load() {
      try {
        const restaurantId = getRestaurantId();
        if (!restaurantId) {
          throw new Error("Restaurant ID not found in stored questions");
        }

        const loyaltyData = await fetchLoyaltyData(restaurantId,"all");
        
        if (!ignore) {
          setData(loyaltyData.attendance);
          setNewData(loyaltyData.newAttendance);
        //   console.log("XXXXnewData", newData);

          setOfferData({
            l1Offer: loyaltyData.profile.l1Offer,
            l2Offer: loyaltyData.profile.l2Offer,
            l1OfferValidity: loyaltyData.profile.l1OfferValidity,
            l2OfferValidity: loyaltyData.profile.l2OfferValidity,
          })
          setStatus("ready");
        }
      } catch (err) {
        if (!ignore) {
          setErrorMsg(err.message);
          setStatus("error");
        }
      }
    }

    setStatus("loading"); // show the loading state again on refresh
    load();
    return () => {
      ignore = true;
    };
  }, [refreshCount, isHq]);

  if (isHq) {
    return (
      <PageContent title="Loyalty Tracker">
        <p>This Page is Unavailable to account with role HQ</p>
      </PageContent>
    );
  }

  async function handleRefresh() {
    setRefreshStatus("fetching");
    setActionError("");
    const restaurantId = getRestaurantId();
    try {
      const loyaltyData = await fetchLoyaltyData(restaurantId, "new");
      const entries = Array.isArray(loyaltyData.newAttendance)
        ? loyaltyData.newAttendance
        : [];
      setNewData(entries);
      setRefreshStatus("success");
    } catch (err) {
      setRefreshStatus(null);
      setActionError(err.message);
    }
  }

  async function handleAccept(phone,name) {
    // console.log("handleAccept", phone, name);
    setActionError("");
    try {
      const restaurantId = getRestaurantId();
      const result = await acceptLoyaltyEntry(restaurantId, phone,name);
    //   console.log("XXXresult", result);
      // we remove this phone entry from newData
      setNewData((prev) => prev.filter((entry) => entry.phone !== result.phone));
      let obj = {phone : result.phone, customer : result.result.customer,
        visit : result.result.visit}
       
      setData((prev) => {
        const exists = prev.some((entry) => entry.phone === obj.phone);
        if (exists) return prev; // already there — no change
        return [obj, ...prev];
      });
      return result;
    } catch (err) {
      setActionError(err.message);
      return null;
    }
  }
//   console.log("XXXXnewData", newData);
//   console.log("XXXXdata", data);

  return (
    <PageContent title="Loyalty Tracker">
      
      <button
        className={classes.refreshButton}
        onClick={handleRefresh}
        disabled={status === "loading" || refreshStatus === "fetching"}
      >
        {status === "loading" || refreshStatus === "fetching" ? "Refreshing..." : "Refresh"}
      </button>

      {refreshStatus === "fetching" && (
        <p className={classes.refreshStatus}>Fetching...</p>
      )}
      {refreshStatus === "success" && (
        <p className={classes.refreshStatus}>Fetch successful</p>
      )}

      {status === "loading" && <p>Loading customer data...</p>}

      {status === "error" && (
        <p className={classes.error}>Could not load loyalty data: {errorMsg}</p>
      )}

      {status === "ready" && (
        <>
          {actionError && (
            <p className={classes.error}>Action failed: {actionError}</p>
          )}
            <p>{newData.length + data.length} customer(s)</p>
      <div className={classes.tableContainer}>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              {/* <th>Regular</th> */}
              <th>Total Visits</th>
              <th>Loyalty Score</th>
              <th>Offers</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <LoyaltyTrackerRow data={newData} offerData={offerData} onAccept={handleAccept} />
            <tr>
    <td colSpan={7}> </td>
  </tr>
          <LoyaltyTrackerRow data={data} offerData={offerData} onAccept={handleAccept} />
         
          </tbody>
        </table>
    
          </div>
          </>
      )}
    </PageContent>
  );
}
